import { Component } from '@angular/core';

@Component({
    selector: 'app-insurance-reporting',
    templateUrl: './insurance-reporting.component.html',
    styleUrls: ['./insurance-reporting.component.scss'],
    standalone: false
})
export class InsuranceReportingComponent {

}
